import {
  ResponsiveContainer,
  Cell,
  Pie,
  PieChart,
  Tooltip,
  Legend,
} from "recharts";

const convertToPieData = (data) => {
  return data.map((item) => ({
    name: item.qualification,
    value: item.count,
  }));
};

export default function QualificationVacanciesChart({ data }) {
  const pieData = convertToPieData(data);

  return (
    <ResponsiveContainer width="100%" height={300}>
      <PieChart>
        <Pie
          data={pieData}
          cx="50%"
          cy="50%"
          labelLine={false}
          outerRadius={100}
          fill="#8884d8"
          dataKey="value"
          nameKey="name"
          label={({ name, value, percent }) =>
            `${name}: ${value?.toLocaleString()} (${(percent * 100).toFixed(
              0
            )}%)`
          }
        >
          {pieData.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={`hsl(var(--chart-${index + 1}))`}
            />
          ))}
        </Pie>
        <Tooltip
          formatter={(value, label) => [
            `${value?.toLocaleString()} ${
              value == 1 ? "Vacancy" : "Vacancies"
            }`,
            label,
          ]}
        />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
}
